import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const EnvioInformePrellenado = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/EnvioInformePrellenado",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { EnvioInformePrellenado };
